import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/50256284598', '_blank');
  };
  return <header className="sticky top-0 z-50 bg-pirate-black bg-opacity-95 border-b border-pirate-wood" data-id="element-57">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center" data-id="element-58">
        <div className="flex items-center" data-id="element-59">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eFa5T1mpwhzi4xKfC4a9AH/LOGO_PERLA_NEGRA.png" alt="Perla Negra Logo" className="h-14" data-id="element-60" />
        </div>
        <div className="hidden md:flex items-center space-x-6" data-id="element-61">
          <a href="#angus" className="font-pirata text-lg hover:text-pirate-red transition-colors" data-id="element-62">
            Nuestra Esencia
          </a>
          <a href="#historia" className="font-pirata text-lg hover:text-pirate-red transition-colors" data-id="element-63">
            Historia
          </a>
          <a href="#menu" className="font-pirata text-lg hover:text-pirate-red transition-colors" data-id="element-64">
            Nuestro Menú
          </a>
          <a href="#ubicacion" className="font-pirata text-lg hover:text-pirate-red transition-colors" data-id="element-65">
            Ubicación
          </a>
          <button onClick={handleWhatsAppClick} className="bg-pirate-red border-2 border-white px-4 py-2 rounded-md font-pirata text-white hover:bg-opacity-80 transition-all focus:outline-none focus:ring-2 focus:ring-white" data-id="element-66">
            Haz tu pedido
          </button>
        </div>
        <button onClick={toggleMenu} className="md:hidden text-pirate-red focus:outline-none" data-id="element-67">
          {isMenuOpen ? <X size={28} data-id="element-68" /> : <Menu size={28} data-id="element-69" />}
        </button>
      </div>
      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-pirate-black bg-opacity-95 border-b border-pirate-wood animate-fade-in" data-id="element-70">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-71">
            <a href="#angus" className="font-pirata text-xl py-2 hover:text-pirate-red transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-72">
              Nuestra Esencia
            </a>
            <a href="#historia" className="font-pirata text-xl py-2 hover:text-pirate-red transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-73">
              Historia
            </a>
            <a href="#menu" className="font-pirata text-xl py-2 hover:text-pirate-red transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-74">
              Nuestro Menú
            </a>
            <a href="#ubicacion" className="font-pirata text-xl py-2 hover:text-pirate-red transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-75">
              Ubicación
            </a>
            <button onClick={handleWhatsAppClick} className="bg-pirate-red border-2 border-white px-4 py-2 rounded-md font-pirata text-white text-xl hover:bg-opacity-80 transition-all focus:outline-none focus:ring-2 focus:ring-white" data-id="element-76">
              Haz tu pedido
            </button>
          </div>
        </div>}
    </header>;
};